<template>
    <div class="main-content" id="panel">
        <div class="header bg-primary pb-6">
            <div class="container-fluid">
            <div class="header-body">
                <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h2></h2>
                </div>
                </div>
                
            </div>
            </div>
        </div>
        <div class="container-fluid mt--6" >
            <div class="row justify-content-md-center upload">
                <div class="col-xl-12">
                    <div class="card p-3"  style="min-width: 250px">
                        <div class="card-header bg-transparent">
                            <div class="row align-items-center">
                                <div class="col">
                                    <h5 class="mb-3" v-if="isBranchRiskManager">Broker Dealer Settings</h5>
                                    <h5 class="mb-3" v-if="!isBranchRiskManager">Compliance Settings</h5>
                                </div>
                            </div>
                        </div>
                        <form class="mt-4 comsetting" >
                            <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                            <div class="form-row settings" v-if="trader">
                                <div class="form-group col-md-2 text-left text-uppercase">
                                    <label for="inputEmail4">Capital Invested
                                        <i style="color: orange;"
                                            class="fas fa-info-circle info" 
                                            data-toggle="tooltip" 
                                            v-bind:title="isBranchRiskManager ? 'The Maximum capital allotted by the broker dealer risk manager' : 'The Maximum capital allotted by the risk manager' "></i> 
                                    </label>
                                    <div v-if="trader.maxCapitalConcList.length > 0" class="text-success"> 
                                        {{ trader.maxCapitalConcList[0].concentrationValueDolAmt | currency }}
                                    </div>
                                </div>
                                <!-- <div v-if="isBranchRiskManager" class="form-group col-md-2 text-left">
                                    <label for="inputEmail4">DEPLOYED CAPITAL
                                        <i style="color: orange;"
                                            class="fas fa-info-circle info" 
                                            data-toggle="tooltip" 
                                            v-bind:title="'The total capital allocated to traders by the branch risk manager'"></i> 
                                    </label>
                                    <div v-if="trader.maxCapitalConcList.length > 0" class="text-success"> 
                                        {{ trader.maxCapitalConcList[0].allocatedCapital  | currency }}
                                    </div>
                                </div> -->
                                
                                <div class="form-group col-md-2 text-left text-uppercase">
                                    <label for="inputEmail4 ">Bought Today
                                        <i style="color: orange;"
                                            class="fas fa-info-circle info" 
                                            data-toggle="tooltip" 
                                            v-bind:title="'The total Capital in Today\'s Buys.'"></i> 
                                    </label>
                                    <div v-if="trader.maxCapitalConcList.length > 0" class="text-primary"> 
                                        {{trader.maxCapitalConcList[0].capitalInvestedDolAmt  | currency}}
                                    </div>
                                </div>
                                <!-- <div class="form-group col-md-2 text-left">
                                    <label for="inputEmail4">BID SUBMITTED
                                        <i style="color: orange;"
                                            class="fas fa-info-circle info" 
                                            data-toggle="tooltip" 
                                            v-bind:title="'The total capital allocated to bids.'"></i> 
                                    </label>
                                    <div v-if="trader.maxCapitalConcList.length > 0" class="text-info"> 
                                        {{ trader.maxCapitalConcList[0].biddingDolAmt  | currency}}
                                    </div>
                                </div> -->
                                
                                
                                <div class="form-group col-md-2 text-left">
                                    <label for="inputEmail4">IMS CAPITAL
                                        <i style="color: orange;"
                                            class="fas fa-info-circle info" 
                                            data-toggle="tooltip" 
                                            v-bind:title="'Capital in inventory offerings'"></i> 
                                    </label>
                                    <div v-if="trader.maxCapitalConcList.length > 0" class="text-info"> 
                                        {{trader.maxCapitalConcList[0].invOfferDolAmt   | currency}}
                                    </div>
                                </div>
                                <div class="form-group col-md-1 text-left">
                                    <label for="inputEmail4">AT RISK
                                        <i style="color: orange;"
                                            class="fas fa-info-circle info" 
                                            data-toggle="tooltip" 
                                            v-bind:title="'The combined amount of Bought Today and IMS CAPITAL'"></i> 
                                    </label>
                                    <div v-if="trader.maxCapitalConcList.length > 0" class="text-danger"> 
                                        {{trader.maxCapitalConcList[0].capitalAtRisk   | currency}}
                                    </div>
                                </div>
                                <div v-if="isBranchRiskManager" class="form-group col-md-3 text-left">
                                    <label for="inputEmail4">BRANCH PAR MAX  / AT RISK
                                        <i style="color: orange;"
                                            class="fas fa-info-circle info" 
                                            data-toggle="tooltip" 
                                            v-bind:title="'The limit set by the Broker Dealer Risk Manager on the maximum quantity allowed as longs'"></i> 
                                        
                                    </label>
                                    <div v-if="trader.branchPaxMax" > 
                                       <span class="text-info">{{ formatNumber(trader.branchPaxMax)}}</span>  / <span class="text-warning">{{ formatNumber(trader.branchPaxAtRisk) }}</span>
                                    </div>
                                    <div v-else>
                                        <span  class="text-danger">N/A</span>
                                    </div>
                                </div>
                                <div class="form-group col-md-2 text-left">
                                    <label for="inputEmail4">CUSIP MAX QTY
                                        <i style="color: orange;"
                                            class="fas fa-info-circle info" 
                                            data-toggle="tooltip" 
                                            v-bind:title="isBranchRiskManager ? 'The broker dealer\'s limit on the maximum quantity that can be Bought Today per bond.' :'The risk manager\'s limit on the maximum quantity that can be Bought Today per bond.' "></i> 
                                    </label>
                                    <div v-if="trader.cusipConcList.length > 0" class="text-dark-red">{{ formatNumber(trader.cusipConcList[0].concentrationValue) }} </div>
                                    <div v-else>
                                        <span  class="text-danger">N/A</span>
                                    </div>
                                </div>
                                </div>
                                <div>
                                <div  class="d-flex bd-highlight">
                                    <div>
                                        <h4 style="color: #0087D4;" >STATE</h4>
                                    </div>
                                </div>
                                <div class="table-responsive">
                                    <table class="table align-items-center table-flush table-hover bidtbl">
                                        <thead class="thead-light psticky">
                                        <tr>
                                            <th scope="col" class="sort text-center">STATE</th>
                                            <th scope="col" class="sort text-center">CONC(%)</th>
                                            <th scope="col" class="sort text-center">DOLLAR AMOUNT</th>
                                            <!-- <th v-if="isBranchRiskManager"  scope="col" class="sort text-center">DEPLOYED</th> -->
                                            <th scope="col" class="sort text-center">Bought Today</th>
                                            <th scope="col" class="sort text-center">IMS CAPITAL</th>
                                            <th scope="col" class="sort text-center">AT RISK</th>
                                        </tr>
                                        </thead>
                                        <tbody class="list no-cursor" v-if="trader">
                                            <tr v-if="trader.stateConcList.length == 0">
                                                <td><p class="nodata">No data available</p>
                                                </td>
                                            </tr>
                                            <tr v-for="(state,index) in trader.stateConcList" :key="index">
                                                <td class="text-center">{{ state.concentration }}</td>
                                                <td class="text-center">{{ state.concentrationValue  }}%</td>
                                                <td class="text-center">{{ state.concentrationValueDolAmt  | currency }}</td>
                                                <!-- <td v-if="isBranchRiskManager"  class="text-center">{{ state.allocatedCapital | currency }}</td> -->
                                                <td class="text-center">{{ state.capitalInvestedDolAmt  | currency }}</td>
                                                <td class="text-center">{{ state.invOfferDolAmt | currency }}</td>
                                                <td class="text-center">{{ state.capitalAtRisk | currency }}</td>
                                                
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div  class="d-flex bd-highlight">
                                    <div>
                                        <h4 style="color: #0087D4;" >RATING</h4>
                                    </div>
                                </div>
                                <div class="table-responsive">
                                    <table class="table align-items-center table-flush table-hover bidtbl">
                                        <thead class="thead-light psticky">
                                        <tr>
                                            <th scope="col" class="sort text-center">RATING</th>
                                            <th scope="col" class="sort text-center">CONC(%)</th>
                                            <th scope="col" class="sort text-center">DOLLAR AMOUNT</th>
                                            <!-- <th v-if="isBranchRiskManager"  scope="col" class="sort text-center">DEPLOYED</th> -->
                                            <th scope="col" class="sort text-center">Bought Today</th>
                                            <th scope="col" class="sort text-center">IMS CAPITAL</th>
                                            <th scope="col" class="sort text-center">AT RISK</th>

                                        </tr>
                                        </thead>
                                        <tbody class="list no-cursor" v-if="trader">
                                            <tr v-if="trader.creditRatingConcList.length == 0">
                                                <td><p class="nodata">No data available</p>
                                                </td>
                                            </tr>
                                            <tr v-for="(rating,index) in trader.creditRatingConcList" :key="index">
                                                <td class="text-center">{{ rating.concentrationList[0] }} <span style="font-size: 15px; color: rgb(0, 135, 212);">&rarr;</span> {{ rating.concentrationList[rating.concentrationList.length - 1] }}</td>
                                                <td class="text-center">{{ rating.concentrationValue  }}%</td>
                                                <td class="text-center">{{ rating.concentrationValueDolAmt  | currency }}</td>
                                                <!-- <td v-if="isBranchRiskManager"  class="text-center">{{ rating.allocatedCapital  | currency }}</td> -->
                                                <td class="text-center">{{ rating.capitalInvestedDolAmt  | currency}}</td>
                                                <td class="text-center">{{ rating.invOfferDolAmt  | currency }}</td>
                                                <td class="text-center">{{ rating.capitalAtRisk  | currency }}</td>
                                                
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <!-- <div class="form-group col-md-12 text-center">
                                    <label for="inputEmail4">STATES/CONC/DOLLAR AMOUNT/Bought Today/AT RISK</label>
                                    <div class="listAcc" v-for="(state,index) in trader.stateConcList" :key="index">
                                        <span class="text-warning">{{ state.concentration }} - {{ state.concentrationValue }} - {{ state.concentrationValueDolAmt }} - {{ state.capitalInvestedDolAmt }} -  {{ state.biddingDolAmt}}</span>
                                    </div>
                                </div>
                                <div class="form-group col-md-12 text-center">
                                    <label for="inputEmail4">RATING/CONC/DOLLAR AMOUNT/Bought Today/AT RISK</label>
                                    <div class="listAcc" v-for="(rating,index) in trader.creditRatingConcList" :key="index">
                                        <span class="text-info">{{ rating.concentration }} - {{ rating.concentrationValue }} - {{ rating.concentrationValueDolAmt }} - {{ rating.capitalInvestedDolAmt }} -  {{ rating.biddingDolAmt}}</span>
                                    </div>
                                </div> -->
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>    
</template>
<script>
import authService from "@/authService";
import config from "@/config";

export default {
  name: "imsComponent",
  components : {
   
  },
  watch:{
    $route (){
      this.getCompDetails();
    }
  } , 
  data() {
    return {
        loading : false,
        trader : null,
        isTrader : false,
        isBranchRiskManager : false
    };
  },
  methods: { 
    getTraderData(){
      this.loading = true;
      const auth = {
        headers: {'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
          config.baseUrlAutoBidder + "/autobidder/traders?page=1&size=10&search=&status=ACTIVE&sortColumn=firstName&sortOrder=ASC&group=Trader&cognitoSub="+authService.getUser().cognitoSub+"&startOfDay="+this.moment(this.moment().format("MM-DD-YYYY")).utc().format("YYYY-MM-DD HH:mm:ss"),
          auth
        )
        .then(result => {
            this.trader = result.data.content[0];
            this.loading = false;
        })
        .catch(e => {
          console.log(e);
          this.loading = false;
        });
    },
    getBranchData(){
      this.loading = true;
      const auth = {
        
      };
      this.$http
        .get(
          config.baseUrlAutoBidder + "/compliance/list-branches?branchOrgToken="+authService.getOrgToken()+"&search=&sortColumn=firstName&sortOrder=ASC",
          auth
        )
        .then(result => {
            this.trader = result.data.data[0];
            this.loading = false;
        })
        .catch(e => {
          console.log(e);
          this.loading = false;
        });
    },
    getCompDetails(){
        const urlParams = new URLSearchParams(window.location.search);
        const roleName = urlParams.get('role');
        roleName === 'riskmanager' ? this.isBranchRiskManager = true : this.isBranchRiskManager = false;
        if(this.isBranchRiskManager){
            this.getBranchData();
        }else{
            this.getTraderData();
        }
    }
  },
  mounted() {
  },
  created() {
    this.getCompDetails()
  },
};
</script>
<style scoped>
.listAcc, .comsetting div{
    font-size: 12px;
}
</style>